import BaseApi from "../BaseApi";

class ItemsListType extends BaseApi{
    // add Generic ItemsList
    static async addGenericItemListType(itemPayload) {
    const s_id = itemPayload.s_id ? parseInt(itemPayload.s_id) : null;
    try {
      const { data, error } = await this.supabase.from("item_types").upsert({
        id: itemPayload.id || undefined,
        name: itemPayload.name,
        category: itemPayload.category,
        s_id,
      },{ onConflict: ["id"] }).select().single();

      if (error) {
        return { success: false, error: "Failed to Add or Update Item Type" };
      }
      return { success: true, message: "Successfully Added or Updated Item Type", data };
    } catch (e) {
      return { success: false, error: "Unexpected error occurred" };
    }
  }
    // add Items
    static async addItemListType(itemPayload) {
    const s_id = itemPayload.s_id ? parseInt(itemPayload.s_id) : null;
    try {
      const { data, error } = await this.supabase.from("item_types").upsert({
        id: itemPayload.id || undefined,
        name: itemPayload.name,
        category: itemPayload.category,
        s_id,
      },{ onConflict: ["id"] }).select().single();

      if (error) {
        return { success: false, error: "Failed to Add or Update Item Type" };
      }
      return { success: true, message: "Successfully Added or Updated Item Type", data };
    } catch (e) {
      return { success: false, error: "Unexpected error occurred" };
    }
  }

  // fetch itemtypes details
  static async fetchItemType(searchTerm = "", s_id,) {
    try {
      let query = this.supabase
        .from("item_types")
        .select("*")
        .eq("s_id", s_id)
  
      if (searchTerm) {
        // If ID is numeric, check exact match; else, search name
        const isNumeric = !isNaN(searchTerm);
        const filters = isNumeric
          ? `id.eq.${searchTerm},name.ilike.%${searchTerm}%`
          : `name.ilike.%${searchTerm}%`;
  
        query = query.or(filters);
      }
  
      const { data, error } = await query;
      if (error) throw new Error(error.message);
  
      return data;
    } catch (err) {
      console.error("Error fetching Type:", err);
      return [];
    }
  }

  // delete item by id
  static async deleteitemType(itemid) {
    try {
      const { error } = await this.supabase
        .from("item_types")
        .delete()
        .eq("id", itemid);

      if (error) {
        throw new Error(error.message);
      }
      return true;
    } catch (e) {
      console.error("Error deleting Item:", e);
      return false;
    }
  }

}

export default ItemsListType;